import "bootstrap";
import lastDayOfMonth from "~modules/last-day-of-month";
import cascadeSelectRace from "~modules/cascade-select-race";
import cascadeSelectSpecTire from "~modules/cascade-select-spec-tire";
import { toggleInfoField } from "~modules/shipping-contact";
import calculatePointsPreview from "~modules/calculate-points-preview";
import calculateTireExchangePreview from "~modules/calculate-tire-exchange-preview";
import memberMemo from "~modules/member-memo";

document.addEventListener("DOMContentLoaded", lastDayOfMonth);
document.addEventListener("DOMContentLoaded", cascadeSelectRace);
document.addEventListener("DOMContentLoaded", cascadeSelectSpecTire);
document.addEventListener("DOMContentLoaded", toggleInfoField);
document.addEventListener("DOMContentLoaded", calculatePointsPreview);
document.addEventListener("DOMContentLoaded", calculateTireExchangePreview);
document.addEventListener("DOMContentLoaded", memberMemo);
